import script from "./PrayerPrayableDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./PrayerPrayableDisplay.vue?vue&type=script&setup=true&lang=js"

import "./PrayerPrayableDisplay.vue?vue&type=style&index=0&id=1e1b9fa2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e1b9fa2"]])

export default __exports__